import { Component } from '@angular/core';
import { DataBoxComponent } from '@shared/components/data-box/data-box.component';
import { DataItem } from '@shared/models/data-item';

@Component({
  selector: 'app-sequence-total-info',
  standalone: true,
  imports: [DataBoxComponent],
  templateUrl: './sequence-total-info.component.html',
  styleUrl: './sequence-total-info.component.scss'
})
export class SequenceTotalsInfoComponent {

  titleDeadhead = "Deadhead";
  titleFlight = "Flight";
  titleTotal = "Total";
  titleTAFB = "TAFB";
  dataItemDeadhead: DataItem[] = [
    {
      label: "",
      value: `This is the total of alldeadhead or positioning flight time for the 
      current sequence displayed in hours and minutes.  This is calculated
      as part of the total flight time for this sequence.`
    }
  ];

  dataItemFlight: DataItem[] = [
    {
      label: "",
      value: `This is the actual total flight time for the current sequence displayed 
      in hours and minutes.  Does not include deadheads or cancelled flights,
      only actual flight time.`
    }
  ];

  dataItemTotal: DataItem[] = [
    {
      label: "",
      value: `This is the total flight time for the current sequence displayed 
      in hours and minutes.  It is calculated from the sum of deadhead flight time
      and actual flight time.`
    }
  ];

  dataItemTAFB: DataItem[] = [
    {
      label: "",
      value: `This is the total time away from base for the current sequence 
      displayed in hours and minutes.  It it calculated from the time of sign in
      until the end of the sequence, typically 30 minutes after block in on the 
      last flight of the sequence.`
    }
  ]
}
